<div
  class="color-picker"
  [hidden]="!show"
  [style.visibility]="this.hidden ? 'hidden' : 'visible'"
  [style.height.px]="cpHeight"
  [style.width.px]="cpWidth"
  [style.top.px]="top"
  [style.left.px]="left"
  [style.position]="position"
  #dialogPopup
>
  <div
    [rtColorPickerSlider]
    [style.background-color]="hueSliderColor"
    [rgX]="1"
    [rgY]="1"
    (newValue)="
      setSaturationAndBrightness({ s: $event.s!, v: $event.v!, rgX: $event.rgX!, rgY: $event.rgY! })
    "
    class="saturation-lightness"
  >
    <div [style.left.px]="slider.s" [style.top.px]="slider.v" class="cursor"></div>
  </div>
  <div class="box">
    <div class="left">
      <div class="selected-color-background"></div>
      <div [style.background-color]="selectedColor" class="selected-color"></div>
    </div>
    <div class="right">
      @if (cpAlphaChannel === 'disabled') {
        <div style="height: 18px"></div>
      }

      <div
        [rtColorPickerSlider]
        [rgX]="1"
        (newValue)="setHue({ v: $event.v!, rg: $event.rg! })"
        class="hue"
        #hueSlider
      >
        <div [style.left.px]="slider.h" class="cursor"></div>
      </div>

      <div
        [hidden]="cpAlphaChannel === 'disabled'"
        [rtColorPickerSlider]
        [style.background-color]="alphaSliderColor"
        [rgX]="1"
        (newValue)="setAlpha({ v: $event.v!, rg: $event.rg! })"
        class="alpha"
        #alphaSlider
      >
        <div [style.left.px]="slider.a" class="cursor"></div>
      </div>
    </div>
  </div>

  <div layout-horizontal>
    <div class="color-inputs-wrapper">
      <div [hidden]="format !== 2" class="hsla-text">
        <div class="box">
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="360"
            [rg]="360"
            (newValue)="setHue($event)"
            [value]="hslaText.h"
          />
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="100"
            [rg]="100"
            (newValue)="setSaturation($event)"
            [value]="hslaText.s"
          />
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="100"
            [rg]="100"
            (newValue)="setLightness($event)"
            [value]="hslaText.l"
          />
          @if (cpAlphaChannel !== 'disabled') {
            <input
              [rtColorPickerText]
              type="number"
              pattern="[0-9]+([\.,][0-9]{1,2})?"
              min="0"
              max="1"
              step="0.1"
              [rg]="1"
              (newValue)="setA($event)"
              [value]="hslaText.a"
            />
          }
        </div>
        <div class="box">
          <div>H</div>
          <div>S</div>
          <div>L</div>
          @if (cpAlphaChannel !== 'disabled') {
            <div>A</div>
          }
        </div>
      </div>

      <div [hidden]="format !== 1" class="rgba-text">
        <div class="box">
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="255"
            [rg]="255"
            (newValue)="setR($event)"
            [value]="rgbaText.r"
          />
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="255"
            [rg]="255"
            (newValue)="setG($event)"
            [value]="rgbaText.g"
          />
          <input
            [rtColorPickerText]
            type="number"
            pattern="[0-9]*"
            min="0"
            max="255"
            [rg]="255"
            (newValue)="setB($event)"
            [value]="rgbaText.b"
          />
          @if (cpAlphaChannel !== 'disabled') {
            <input
              [rtColorPickerText]
              type="number"
              pattern="[0-9]+([\.,][0-9]{1,2})?"
              min="0"
              max="1"
              step="0.1"
              [rg]="1"
              (newValue)="setA($event)"
              [value]="rgbaText.a"
            />
          }
        </div>
        <div class="box">
          <div>R</div>
          <div>G</div>
          <div>B</div>
          @if (cpAlphaChannel !== 'disabled') {
            <div>A</div>
          }
        </div>
      </div>

      <div [hidden]="format !== 0" class="hex-text">
        <div class="box">
          <input [rtColorPickerText] (newTextValue)="setHex($event)" [value]="hexText" />
        </div>
        <div class="box">
          <div>Hex</div>
        </div>
      </div>
    </div>

    <rt-icon-button
      variant="plain"
      (click)="formatPolicy()"
      iconName="import-export"
      shape="square"
      class="change-input-type"
    ></rt-icon-button>
  </div>

  @if (cpPresetColors && cpPresetColors.length) {
    <div class="preset-area">
      <hr />

      <div class="preset-label">{{ cpPresetLabel }}</div>

      @for (color of cpPresetColors; track trackBy($index, color)) {
        <div
          class="preset-color"
          [style.backgroundColor]="color"
          (click)="setColorFromString(color)"
        ></div>
      }
    </div>
  }

  @if (cpOKButton || cpCancelButton) {
    <div class="button-area">
      @if (cpOKButton) {
        <button type="button" class="{{ cpOKButtonClass }}" (click)="oKColor()">
          {{ cpOKButtonText }}
        </button>
      }
      @if (cpCancelButton) {
        <button type="button" class="{{ cpCancelButtonClass }}" (click)="cancelColor()">
          {{ cpCancelButtonText }}
        </button>
      }
    </div>
  }
</div>
